import OurGreatestHits from './OurGreatestHits'
import PageScrollSmoother from '../PageScrollSmoother'
import ShowcaseButtons from './ShowcaseButtons'
// import BigHeading from "./BigHeading";

export default class WhatWeDo {
  static instance;

  constructor() {
    if (WhatWeDo.instance) {
      return WhatWeDo.instance;
    }
    WhatWeDo.instance = this;

    this.scrollSmoother = new PageScrollSmoother();
    this.showcaseButtons = new ShowcaseButtons();
    this.ourGreatestHits = new OurGreatestHits();
    // new BigHeading();
  }
}
